import React, { useState, useEffect } from 'react';
import { MapPin, User, Info } from 'lucide-react';
import { UserLocation } from '../types';
import { useAuth } from '../context/AuthContext';
import { AuthModal } from './Auth/AuthModal';
import { UserProfile } from './UserProfile';

interface HeaderProps {
  userLocation: UserLocation | null;
}

export const Header: React.FC<HeaderProps> = ({ userLocation }) => {
  const { user, signOut } = useAuth();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [showIpInfo, setShowIpInfo] = useState(false);

  useEffect(() => {
    if (!user && isProfileOpen) {
      setIsProfileOpen(false);
    }
  }, [user]);

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center flex-shrink-0">
            <img 
              src="https://i.ibb.co/xKYr1D9P/Group-1211720.png" 
              alt="Мой Куток" 
              className="h-8 md:h-12 w-auto"
            />
          </div>
          
          <div className="flex items-center gap-2 md:gap-4">
            {userLocation && (
              <div className="relative flex flex-col items-start text-gray-600">
                <div className="flex items-center gap-2">
                  <MapPin size={20} />
                  <span>{userLocation.city}</span>
                  {userLocation.source === 'ip' && (
                    <button
                      onClick={() => setShowIpInfo(!showIpInfo)}
                      className="ml-1 p-1 rounded-full bg-gray-100 hover:bg-gray-200"
                    >
                      <Info size={14} />
                    </button>
                  )}
                </div>
                {userLocation.source === 'ip' && showIpInfo && (
                  <div className="absolute left-0 mt-1 bg-white border border-gray-200 rounded-lg p-2 text-xs shadow-lg z-50 w-48">
                    Лакацыя вызначана па IP. Для больш дакладнай лакацыі дазвольце доступ да GPS.
                  </div>
                )}
              </div>
            )}

            {user ? (
              <button
                onClick={() => setIsProfileOpen(true)}
                className="flex items-center gap-1 md:gap-2 px-2 md:px-4 py-1.5 md:py-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"
              >
                <User size={18} className="text-gray-600" />
                <span className="hidden md:inline text-gray-600">{user.email}</span>
              </button>
            ) : (
              <button
                onClick={() => {
                  setAuthMode('login');
                  setIsAuthModalOpen(true);
                }}
                className="flex items-center gap-1 md:gap-2 px-2 md:px-4 py-1.5 md:py-2 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors"
              >
                <User size={18} />
                <span className="hidden md:inline">Увайсці</span>
              </button>
            )}
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        initialMode={authMode}
      />

      <UserProfile
        isOpen={isProfileOpen}
        onClose={() => setIsProfileOpen(false)}
      />
    </header>
  );
};